import { string, bool, node } from 'prop-types';
import { Helmet } from 'react-helmet';

import LoadingBar from 'components/styled/LoadingBar/LoadingBar';
import { Section, Wrapper, LoadingBarWrapper } from './Glossary.style';

const GlossaryWrapper = ({ title, modal, loading, children }) => {
  return (
    <>
      <Helmet defer={false} title={title} />
      <Section>
        <Wrapper modal={modal}>
          <LoadingBarWrapper>
            <LoadingBar loading={loading} />
          </LoadingBarWrapper>
          {children}
        </Wrapper>
      </Section>
    </>
  );
};

GlossaryWrapper.propTypes = {
  /** Title of the glossary */
  title: string.isRequired,
  /** Boolean indicating if this component is displayed in a modal */
  modal: bool.isRequired,
  /** Boolean indicating if this component is in loading state */
  loading: bool.isRequired,
  /** React children */
  children: node.isRequired,
};

export default GlossaryWrapper;
